import React from "react";
import './style.css'

const Sorter = (props) => {
	const {sortBy, setSortBy} = props;

	const handleSort = (event) =>{
		setSortBy(event.target.value)
	}
    return (
		<div className='container-box'>
			<h1 className="filtro-heading">ORDENAR RESULTADOS</h1>
			{/* <div className="separador"></div> */}
			<div className="bloque">
				<select className="form-select form-select-sm" onChange={handleSort}>
					<option value="default" selected disabled>Por defecto</option>
					<option value="puntuacion">Valoración</option>
					<option value="distancia">Distancia</option>
				</select>
			</div>
		</div>
	);
}

export default Sorter;